<div
  class="h-full flex flex-col bg-white dark:bg-neutral-800 border-t border-s border-gray-200 dark:border-neutral-700"
>
  <!-- Header -->
  <div
    class="flex items-center justify-between px-4 py-3 border-b border-gray-200 dark:border-neutral-700"
  >
    <div class="flex items-center gap-2">
      <i class="bi bi-journal-text text-blue-500 text-lg"></i>
      <h3 class="text-sm font-semibold text-gray-900 dark:text-white">
        Minhas Anotações
      </h3>
    </div>
    @if (noteContent) {
    <button
      type="button"
      (click)="onClearNote()"
      class="inline-flex items-center justify-center p-1.5 text-xs text-gray-500 hover:text-gray-700 dark:text-neutral-400 dark:hover:text-neutral-200 transition-colors"
      title="Limpar anotação"
    >
      <i class="bi bi-trash"></i>
    </button>
    }
  </div>

  <!-- Status de Salvamento -->
  @if (saving) {
  <div
    class="px-4 py-2 bg-blue-50 dark:bg-blue-900/20 border-b border-blue-200 dark:border-blue-800"
  >
    <div
      class="flex items-center gap-2 text-xs text-blue-600 dark:text-blue-400"
    >
      <i class="bi bi-arrow-repeat animate-spin"></i>
      <span>Salvando...</span>
    </div>
  </div>
  }

  <!-- Erro de Salvamento -->
  @if (saveError) {
  <div
    class="px-4 py-2 bg-red-50 dark:bg-red-900/20 border-b border-red-200 dark:border-red-800"
  >
    <div class="flex items-center gap-2 text-xs text-red-600 dark:text-red-400">
      <i class="bi bi-exclamation-circle"></i>
      <span>{{ saveError }}</span>
    </div>
  </div>
  }

  <!-- Textarea -->
  <div class="flex-1 min-h-0 p-4">
    <textarea
      [(ngModel)]="noteContent"
      (input)="onNoteChange($event)"
      placeholder="Digite suas anotações sobre esta lição..."
      class="w-full h-full resize-none border-0 focus:ring-0 focus:outline-none bg-transparent text-sm text-gray-900 dark:text-white placeholder:text-gray-400 dark:placeholder:text-neutral-500"
      rows="10"
    ></textarea>
  </div>

  <!-- Footer com dica -->
  <div
    class="px-4 py-2 bg-gray-50 dark:bg-neutral-900 border-t border-gray-200 dark:border-neutral-700"
  >
    <p class="text-xs text-gray-500 dark:text-neutral-400">
      <i class="bi bi-info-circle"></i>
      Suas anotações são salvas automaticamente
    </p>
  </div>
</div>
